import type { TaskEntry, TaskStatus } from "./types";

// the four columns of the tasks board, in order
export const TASK_STATUSES: TaskStatus[] = ["todo", "doing", "blocked", "done"];

export function taskKey(task: Pick<TaskEntry, "source" | "id">): string {
  return `${task.source}:${task.id}`;
}

// the ChiX inbox, where tasks added in discord land. it can't be renamed or deleted
export const CHIX_INBOX = "chix";
export const CHIX_INBOX_NAME = "ChiX";

// the board tuner key a task answers to
export function boardKey(task: Pick<TaskEntry, "source" | "board" | "boardId">): string {
  return task.source === "chix" ? task.boardId || CHIX_INBOX : `plane:${task.board}`;
}
